import { render, staticRenderFns } from "./AddRepository.vue?vue&type=template&id=446ed8a4&scoped=true"
import script from "./AddRepository.vue?vue&type=script&lang=js"
export * from "./AddRepository.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ed8a4",
  null
  
)

export default component.exports